// Who sees "Unassign" in the open ticket's header: its owner, or an administrator. Clicking it opens
// the Reject & Unassign modal, so the ticket is rejected and handed back the same way.

export interface UnassignVisibilityInput {
  ownerId: number | null;
  currentUserId: string | number | null | undefined;
  /** An administrator (canManageSentinelMembersAtom). */
  isAdmin: boolean;
  isSentinel: boolean;
}

/** An owned ticket can be given up by its owner, or by an administrator who is not a Sentinel. */
export function canUnassignTicket({ ownerId, currentUserId, isAdmin, isSentinel }: UnassignVisibilityInput): boolean {
  if (ownerId === null) return false;
  if (isAdmin && !isSentinel) return true;
  return currentUserId != null && String(currentUserId) === String(ownerId);
}
